export default __webpack_public_path__ + "static/media/freight-service-showcase.a427f8f7.png";